var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0,3.761,3.761,0,12,8.239,20.239,0,24,3.761,15.582,12,24,20.239,20.239,24,12,15.582,3.761,24,0,20.239,8.239,12Z"}));
}

Close.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Close;

Close.default = Close;
